import { render, staticRenderFns } from "./OrderDetailView.vue?vue&type=template&id=85e3c4c8&"
import script from "./OrderDetailView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports